import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import get from 'lodash.get';
import {
  Element,
  AnchorTarget,
  BannerCardArtWithCtaAndBackground
} from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { cmComponentPznExt } from 'src/universal/utils/orchestraCmPznExtEvent';
import { getBannerPznData } from './redux';

import styles from './__styles__/index.scss?modules';

const getImgUrlByPartialKey = (list = [], key) => {
  const imgObj = list.find(item => {
    return (
      String(item.type)
        .toLowerCase()
        .indexOf(String(key).toLowerCase()) > -1
    );
  });
  return imgObj ? imgObj.url : '';
};

const CmBanner = ({
  content,
  labels,
  showBanner,
  maxContentWidth,
  impressionDtm,
  ctaClickDtm,
  display = true
}) => {
  if (!showBanner) {
    return null;
  }

  const backImgUrl = getImgUrlByPartialKey(content.assets, 'background') || '';
  const cardArtUrl = getImgUrlByPartialKey(content.assets, 'cardArt');
  const missingCardArt = true;
  const tncLinks = content.tncLinks || {};
  const disclaimerList = Object.keys(tncLinks).reduce((list, key) => {
    const tncObj = tncLinks[key] || {};
    if (tncObj.url) {
      list.push({
        url: tncObj.url,
        text: <Sanitizer safelySetInnerHTML={labels[key]} />,
        onClick: () => {
          sendDTMClickEvent(tncObj.dtm || {});
        },
        target: AnchorTarget.Blank
      });
    }
    return list;
  }, []);

  const onMetricTracking = () => {
    if (content) {
      cmComponentPznExt([
        {
          id: content.treatmentId,
          compId: content.componentId,
          iaCode: content.cardObjIaCode
        }
      ]);
    }
  };

  return (
    <Element
      className={clsx(
        styles.CmBannerOuter,
        styles[`img_${content.componentIaCode || ''}`],
        styles[`maxWidth${maxContentWidth}`],
        { [styles.display]: display },
        { [styles.missingCardArt]: missingCardArt }
      )}
    >
      <LazyScrollMetricTracker
        scrollDtm={display && impressionDtm}
        callBackFunction={display && onMetricTracking}
      />
      <BannerCardArtWithCtaAndBackground
        data={{
          card: {
            cardImage: cardArtUrl,
            cardName: <Sanitizer safelySetInnerHTML={content.title} />,
            cardFee: <Sanitizer safelySetInnerHTML={content.text} />
          },
          title: <Sanitizer safelySetInnerHTML={content.header} />,
          ctas: [
            {
              Component: 'a',
              text: get(content, 'links[0].text') || '',
              url: get(content, 'links[0].url') || '',
              onClick: () => {
                sendDTMClickEvent(ctaClickDtm || {});
              }
            }
          ],
          disclaimerLinks: disclaimerList,
          copy: <Sanitizer safelySetInnerHTML={get(content, 'description') || ''} />,
          bgImage: backImgUrl
        }}
      />
    </Element>
  );
};

const mapStateToProps = state => {
  return { ...getBannerPznData(state) };
};

export default connect(mapStateToProps)(CmBanner);
